import { Component, OnInit } from '@angular/core';
import { Router, RouterModule, RouterOutlet } from '@angular/router';
@Component({
  selector: 'app-study-environment',
  templateUrl: './study-environment.component.html',
  standalone: true,
  imports: [RouterModule],
  styleUrls: ['./study-environment.component.css']
})
export class StudyEnvironmentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
